import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Widget from '../Widget';
import Avatar from '../Avatar';
import WidgetTable from './Shared/WidgetTable';

export default class CommunityActivityWidget extends Component {
  static propTypes = {
    seeMoreUrl: PropTypes.string.isRequired,
  }

  // Render Main screen using the data from `run_query`

  renderMainScreen(data) {
    return (
      <WidgetTable
        headerRow={
          <tr>
            <th className="u-w-5/6">ACTION</th>
            <th className="u-text-right">TIMESTAMP</th>
          </tr>
        }
        dataRows={data.map(item => this.renderRow(item))}
        seeMoreUrl={this.props.seeMoreUrl} />
    );
  }

  renderRow(item) {
    return (
      <tr key={item.id}>
        <td>{this.renderActivity(item)}</td>
        <td className="u-text-right" dangerouslySetInnerHTML={{ __html: item.time_ago_html }} />
      </tr>
    );
  }

  renderActivity(item) {
    return (
      <div className="u-flex u-items-center" style={{ width: '56rem' }}>
        {this.renderAvatar(item.user)}
        <span className="u-truncate" dangerouslySetInnerHTML={{ __html: item.summary_html }} />
      </div>
    );
  }

  renderAvatar(user) {
    return (
      <Avatar
        src={user.avatar.url}
        name={user.full_name}
        className="u-h-6 u-w-6 u-mr-2 u-flex-shrink-0"
      />
    );
  }

  render() {
    return (
      <Widget
        renderMainScreen={this.renderMainScreen.bind(this)}
        {...this.props}
      />
    );
  }
}
